<template>
  <TimeDisplay :duration="timeLeft" v-bind="$attrs" #default="timeData">
    <slot v-bind="timeData" />
  </TimeDisplay>
</template>

<script>
import TimeDisplay from "./TimeDisplay.vue";

export default {
  name: "Timer",
  inheritAttrs: false,
  components: {
    TimeDisplay
  },
  props: {
    duration: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      timeLeft: 0,
      interval: null
    };
  },
  watch: {
    duration() {
      this.restart();
    }
  },
  mounted() {
    this.restart();
  },
  methods: {
    tick() {
      --this.timeLeft;
      this.$emit("tick", this.timeLeft);

      if (this.timeLeft <= 0) {
        clearInterval(this.interval);
        this.$emit("expired");
      }
    },
    restart() {
      this.start(this.duration);
    },
    start(duration) {
      clearInterval(this.interval);
      duration = Math.floor(duration);
      this.timeLeft = duration > 0 ? duration : 0;
      if (this.timeLeft <= 0) {
        this.$emit("expired");
        return;
      }

      this.tick();
      this.interval = setInterval(this.tick, 1000);
    }
  }
};
</script>
